import { render, staticRenderFns } from "./ManageAddresses.vue?vue&type=template&id=2a45f5b0"
import script from "./ManageAddresses.vue?vue&type=script&lang=js"
export * from "./ManageAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports